import type { GetStaticPropsResult } from 'next'

export class NotFoundError extends Error {
  constructor (message?: string) {
    super(message)
    this.name = 'NotFoundError'
  }
}

export class InternalServerError extends Error {
  constructor (message?: string) {
    super(message)
    this.name = 'InternalServerError'
  }
}

export function handlePrefetchError<T> (error: unknown | any): GetStaticPropsResult<T> {
  if (error instanceof NotFoundError) {
    return {
      notFound: true,
      revalidate: 600,
    }
  } else {
    // Transient/unknown error (Pimcore blip, network, 5xx). Do NOT return `notFound` —
    // that caches a 404 and, with stale-while-revalidate across replicas, sticks for
    // minutes. Rethrow so ISR keeps serving the last good page (or 500s) and retries,
    // never poisoning the cache with a false 404.
    console.log('=============== ERROR ===============')
    console.log('There was an error building the page')
    console.log(error.message)
    console.log('=====================================')
    throw error
  }
}
